module.exports = (__webpack_require__(807379))(6540);